/* Avennura routine quiz: five steps, weighted scoring, add-to-cart result. */
(function () {
  const root = document.querySelector('[data-rquiz]');
  if (!root) return;

  const PRODUCTS = (() => {
    const tag = root.querySelector('[data-rq-products]');
    try { return JSON.parse(tag.textContent); } catch (e) { return {}; }
  })();

  const SKU = {
    clarity: 'vitality-mushroom-coffee-medium-roast',
    reset: 'max-detox-acai-detox',
    ease: 'digestive-gut-health-strips',
    steady: 'ashwagandha',
    balance: 'appetite-balance-weight-support-strips',
    unwind: 'magnesium-glycinate',
    glow: 'hair-skin-nails-gummies'
  };

  const STEPS = [
    {
      key: 'name',
      kind: 'text',
      q: 'First things first. What should we call you?',
      hint: 'So we can make this yours.',
      placeholder: 'Your first name'
    },
    {
      key: 'needs',
      kind: 'multi',
      q: 'What does your day need most?',
      hint: 'Pick everything that sounds like you.',
      options: [
        { label: 'Focus without the jitters', score: { clarity: 3, steady: 1 } },
        { label: 'Less bloat, lighter days', score: { reset: 3, ease: 2 } },
        { label: 'Comfort after meals', score: { ease: 3, reset: 1 } },
        { label: 'Calm through the stress', score: { steady: 3, unwind: 1 } },
        { label: 'Deeper, easier sleep', score: { unwind: 3, steady: 1 } },
        { label: 'Stronger hair, skin and nails', score: { glow: 3 } },
        { label: 'A steadier relationship with food', score: { balance: 3, ease: 1 } },
        { label: 'Honestly, all of it', score: { clarity: 1, reset: 1, ease: 1, steady: 1, unwind: 1, glow: 1, balance: 1 } }
      ]
    },
    {
      key: 'when',
      kind: 'single',
      q: 'When does your day usually derail?',
      hint: 'The moment you would most like back.',
      options: [
        { label: 'The moment I wake up', score: { clarity: 3 } },
        { label: 'Right after I eat', score: { ease: 3, balance: 1 } },
        { label: 'That 3 PM wall', score: { steady: 3, clarity: 1 } },
        { label: 'Evening, when I finally sit down', score: { unwind: 3 } },
        { label: 'It is more of a slow, all-day thing', score: { reset: 2, glow: 2, steady: 1 } }
      ]
    },
    {
      key: 'format',
      kind: 'single',
      q: 'How do you like to take things?',
      hint: 'The format you will actually stick with.',
      options: [
        { label: 'In my morning coffee', score: { clarity: 3 } },
        { label: 'Simple capsules', score: { reset: 2, steady: 2, unwind: 2 } },
        { label: 'A strip that melts on my tongue', score: { ease: 3, balance: 3 } },
        { label: 'Something that tastes good', score: { glow: 3, ease: 1, balance: 1 } },
        { label: 'I am not fussy', score: {} }
      ]
    },
    {
      key: 'avoid',
      kind: 'multi',
      q: 'Anything we should steer around?',
      hint: 'Optional. We will filter your routine.',
      options: [
        { label: 'No caffeine', exclude: ['clarity'] },
        { label: 'Vegan only', exclude: ['glow'] },
        { label: 'Keep the sugar minimal', exclude: ['glow'] },
        { label: 'No fish or shellfish', exclude: ['glow'] },
        { label: 'Nothing to avoid', exclude: [] }
      ]
    }
  ];

  const state = { i: 0, name: '', answers: {} };
  const shell = root.querySelector('[data-rq-shell]');
  const intro = root.querySelector('[data-rq-intro]');
  const stage = root.querySelector('[data-rq-stage]');
  const result = root.querySelector('[data-rq-result]');
  const bar = root.querySelector('[data-rq-bar]');
  const stepNum = root.querySelector('[data-rq-step]');
  const nextBtn = root.querySelector('[data-rq-next]');
  const backBtn = root.querySelector('[data-rq-back]');

  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function render() {
    const step = STEPS[state.i];
    stepNum.textContent = state.i + 1;
    bar.style.width = ((state.i) / STEPS.length * 100) + '%';
    backBtn.hidden = state.i === 0;

    let q = step.q;
    if (state.name && state.i > 0) q = state.name + ', ' + q.charAt(0).toLowerCase() + q.slice(1);

    let html = '<p class="rquiz__q">' + esc(q) + '</p>';
    if (step.hint) html += '<p class="rquiz__hint">' + esc(step.hint) + '</p>';

    if (step.kind === 'text') {
      html += '<input class="rquiz__input" type="text" data-rq-text placeholder="' + esc(step.placeholder) + '" autocomplete="given-name">';
    } else {
      const picked = state.answers[step.key] || [];
      html += '<div class="rquiz__options">';
      step.options.forEach((o, idx) => {
        const on = picked.indexOf(idx) > -1 ? ' is-on' : '';
        html += '<button class="rquiz__opt' + on + '" type="button" data-rq-opt="' + idx + '">' + esc(o.label) + '</button>';
      });
      html += '</div>';
    }
    stage.innerHTML = html;

    const input = stage.querySelector('[data-rq-text]');
    if (input) {
      input.value = state.name;
      input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); next(); } });
      setTimeout(() => input.focus(), 60);
    }

    stage.querySelectorAll('[data-rq-opt]').forEach(b => {
      b.addEventListener('click', () => {
        const idx = +b.dataset.rqOpt;
        const cur = state.answers[step.key] || [];
        if (step.kind === 'single') {
          state.answers[step.key] = [idx];
          render();
          setTimeout(next, 220);
        } else {
          const at = cur.indexOf(idx);
          if (at > -1) cur.splice(at, 1); else cur.push(idx);
          state.answers[step.key] = cur;
          b.classList.toggle('is-on');
        }
      });
    });

    nextBtn.textContent = state.i === STEPS.length - 1 ? 'See my routine' : 'Continue';
  }

  function next() {
    const step = STEPS[state.i];
    if (step.kind === 'text') {
      const input = stage.querySelector('[data-rq-text]');
      state.name = (input && input.value.trim().slice(0, 24)) || '';
    }
    if (state.i < STEPS.length - 1) { state.i++; render(); }
    else finish();
  }

  function back() { if (state.i > 0) { state.i--; render(); } }

  function score() {
    const totals = {};
    Object.keys(SKU).forEach(k => totals[k] = 0);
    const reasons = {};

    STEPS.forEach(step => {
      if (!step.options) return;
      (state.answers[step.key] || []).forEach(idx => {
        const o = step.options[idx];
        if (o.score) {
          Object.keys(o.score).forEach(k => {
            totals[k] += o.score[k];
            if (o.score[k] >= 3 && !reasons[k]) reasons[k] = o.label;
          });
        }
      });
    });

    // exclusions
    const excluded = {};
    const avoid = state.answers.avoid || [];
    avoid.forEach(idx => {
      const o = STEPS[4].options[idx];
      (o.exclude || []).forEach(k => excluded[k] = true);
    });

    const ranked = Object.keys(totals)
      .filter(k => !excluded[k] && PRODUCTS[SKU[k]])
      .sort((a, b) => totals[b] - totals[a]);

    return { ranked, totals, reasons };
  }

  // ---- result rendering ----------------------------------------------------

  const GROUP = {
    clarity: { name: 'Focus & Morning Energy', why: 'a calm, focused start without the caffeine crash' },
    reset: { name: 'Daily Digestion', why: 'a gentle daily rhythm instead of a harsh cleanse' },
    ease: { name: 'After-Meal Comfort', why: 'support at the moment your meal lands, not hours later' },
    steady: { name: 'Stress & Steady Energy', why: 'a calmer baseline when everything is asking for your attention' },
    balance: { name: 'Mindful Eating', why: 'a pause between the craving and the habit' },
    unwind: { name: 'Deep Rest', why: 'evenings that finally let go, and mornings that feel new' },
    glow: { name: 'Hair, Skin & Nails', why: 'beauty grown from the inside, one honest day at a time' }
  };

  function pickReviews(p, n) {
    const arr = Array.isArray(p.reviews_ld) ? p.reviews_ld : [];
    if (!arr.length) return [];
    const list = arr
      .filter(r => Number((r.reviewRating || {}).ratingValue) === 5)
      .map(r => ({
        author: (r.author && (r.author.name || r.author)) || 'Verified Buyer',
        body: String(r.reviewBody || r.description || '').trim()
      }))
      .map(r => ({ author: r.author, body: r.body, short: r.body.length > 150 ? r.body.slice(0, 145).replace(/s+S*$/, '') + String.fromCharCode(8230) : null }))
      .filter(r => r.body.length > 40);
    // de-duplicate near-identical bodies
    const seen = {}, out = [];
    for (const r of list) {
      const k = r.body.slice(0, 40).toLowerCase();
      if (seen[k]) continue;
      seen[k] = 1; out.push(r);
      if (out.length >= n) break;
    }
    return out;
  }

  const stars = () => '<span class="rquiz-stars" aria-hidden="true">' + '&#9733;'.repeat(5) + '</span>';

  const LOADING_LINES = [
    'Reading your answers, every one of them',
    'Matching your day to our formulas',
    'Leaving out anything you told us to avoid',
    'Finishing your routine'
  ];

  function finish() {
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    shell.hidden = true;
    result.hidden = false;

    const check =
      '<svg class="rquiz-load-row__mark" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<circle cx="8" cy="8" r="7.2" stroke="currentColor" stroke-width="1.2"></circle>' +
      '<path class="rquiz-load-row__tick" d="m4.9 8.3 2.1 2.1 4.1-4.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>';

    let rows = '';
    LOADING_LINES.forEach(function (line, i) {
      rows += '<div class="rquiz-load-row" data-rq-row="' + i + '">' + check + '<span>' + line + '</span></div>';
    });

    result.innerHTML =
      '<div class="rquiz-loading" data-rq-loading>' +
      '<p class="rquiz-loading__text">Building <em>your</em> routine' +
      '<span class="rquiz-loading__dots"><span>.</span><span>.</span><span>.</span></span></p>' +
      '<svg class="rquiz-loading__mark" width="54" height="72" viewBox="0 0 54 72" fill="none" aria-hidden="true">' +
      '<rect x="2.6" y="2.6" width="22" height="66.8" rx="11" stroke="currentColor" stroke-width="2"></rect>' +
      '<rect x="29.4" y="2.6" width="22" height="66.8" rx="11" stroke="currentColor" stroke-width="2"></rect>' +
      '</svg>' +
      '<div class="rquiz-loading__list">' + rows + '</div>' +
      '<div class="rquiz-loading__bar" aria-hidden="true"><span data-rq-loadbar></span></div>' +
      '<p class="rquiz-loading__care">Give us a moment. We would rather get this right than get it fast.</p>' +
      '</div>';
    result.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const total = reduced ? 1200 : 4200;
    const barEl = result.querySelector('[data-rq-loadbar]');
    barEl.style.transitionDuration = total + 'ms';
    void barEl.offsetWidth;
    setTimeout(function () { barEl.style.width = '100%'; }, 30);

    const rowEls = result.querySelectorAll('[data-rq-row]');
    const stepGap = total / (LOADING_LINES.length + 0.6);
    rowEls.forEach(function (row, i) {
      setTimeout(function () {
        if (!row.isConnected) return;
        row.classList.add('is-active');
        const prev = rowEls[i - 1];
        if (prev) prev.classList.add('is-done');
      }, Math.round(stepGap * i) + 350);
    });
    setTimeout(function () {
      const last = rowEls[rowEls.length - 1];
      if (last && last.isConnected) last.classList.add('is-done');
    }, total - 350);

    setTimeout(function () {
      const loadEl = result.querySelector('[data-rq-loading]');
      if (loadEl) loadEl.classList.add('is-leaving');
      setTimeout(renderResult, reduced ? 0 : 380);
    }, total);
  }

  function renderResult() {
    bar.style.width = '100%';
    const { ranked, totals, reasons } = score();
    const lead = ranked.length ? totals[ranked[0]] : 0;
    const floor = Math.max(2, lead * 0.4);
    let picks = ranked.filter(k => totals[k] >= floor).slice(0, 3);
    if (picks.length < 2) picks = ranked.slice(0, 2);

    const leadKey = picks[0];
    const group = GROUP[leadKey] || { name: 'Daily Wellness', why: 'a routine that fits the way your day actually runs' };
    const hi = state.name ? esc(state.name) + ', here is your routine' : 'Your Recommendation for ' + group.name;

    let html = '<div class="rquiz__result-head">' +
      '<p class="eyebrow">Your Avennura Method</p>' +
      '<h3 class="rquiz__result-title">' + hi + '</h3>' +
      '<p class="rquiz__result-sub">This is the routine we would build for ' + esc(group.why) +
      '. Every formula below is made in an NSF certified, FDA registered US facility and tested lot by lot.*</p>' +
      '</div>';

    // social proof from the lead product's real reviews
    const leadProduct = PRODUCTS[SKU[leadKey]];
    const revs = leadProduct ? pickReviews(leadProduct, 2) : [];
    if (revs.length) {
      html += '<div class="rquiz__proof">';
      revs.forEach(r => {
        html += '<figure class="rquiz-proof">' +
          '<div class="rquiz-proof__media"><img src="' + leadProduct.image + '" alt="" loading="lazy"></div>' +
          '<figcaption class="rquiz-proof__body">' +
          '<div class="rquiz-proof__top"><span class="rquiz-proof__name">&ndash; ' + esc(r.author) + '</span>' +
          '<span class="rquiz-proof__badge">Verified Buyer</span></div>' +
          stars() +
          '<blockquote class="rquiz-proof__text" data-rq-quote>&ldquo;<span data-rq-short>' + esc(r.short || r.body) + '</span><span data-rq-full hidden>' + esc(r.body) + '</span>&rdquo;</blockquote>' +
          (r.short ? '<button class="rquiz-proof__more" type="button" data-rq-more>Read more</button>' : '') +
          '</figcaption></figure>';
      });
      html += '</div>';
    }

    html += '<div class="rquiz__cards">';
    picks.forEach((k, i) => {
      const p = PRODUCTS[SKU[k]];
      if (!p) return;
      const tag = i === 0 ? 'Your match' : 'Pairs well';
      const why = reasons[k] ? 'Because you said: ' + esc(reasons[k].toLowerCase()) : '';
      const rating = Number(p.rating) || 0;
      html += '<article class="rquiz-card">' +
        '<a class="rquiz-card__media" href="' + p.url + '"><img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
        '<div class="rquiz-card__body">' +
        '<p class="rquiz-card__tag">' + tag + '</p>' +

        '<h4 class="rquiz-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h4>' +



        '<div class="rquiz-card__buys">' +
        (p.selling_plan
          ? '<button class="btn rquiz-card__sub" type="button" data-rq-add="' + p.variant + '" data-rq-plan="' + p.selling_plan + '">Subscribe &amp; save (' + (p.sub_price || p.price) + ')</button>'
          : '') +
        (p.available
          ? '<button class="btn btn--outline rquiz-card__once" type="button" data-rq-add="' + p.variant + '">One time (' + p.price + ')</button>'
          : '<span class="rquiz-card__soldout">Sold out</span>') +
        '</div></div></article>';
    });
    html += '</div>';

    const addAll = picks.map(k => PRODUCTS[SKU[k]]).filter(p => p && p.available).map(p => p.variant);
    html += '<div class="rquiz__result-foot">' +
      (addAll.length > 1 ? '<button class="btn rquiz__addall" type="button" data-rq-addall="' + addAll.join(',') + '">Add all to cart</button>' : '') +
      '<div class="rquiz__result-links">' +
      '<button class="rquiz__restart" type="button" data-rq-restart>Start over</button>' +
      '<a class="rquiz__all" href="/collections/all">See the full collection</a>' +
      '</div>' +
      '<p class="rquiz__disclaimer">*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>' +
      '</div>';

    shell.hidden = true;
    result.hidden = false;
    result.innerHTML = html;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });

    async function addItems(items, btn, doneLabel) {
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding...';
      try {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        btn.textContent = doneLabel;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      } catch (e) {
        btn.textContent = label; btn.disabled = false;
      }
    }

    result.querySelectorAll('[data-rq-more]').forEach(btn => {
      btn.addEventListener('click', () => {
        const q = btn.previousElementSibling;
        const short = q.querySelector('[data-rq-short]');
        const full = q.querySelector('[data-rq-full]');
        const open = !full.hidden;
        full.hidden = open; short.hidden = !open;
        btn.textContent = open ? 'Read more' : 'Show less';
      });
    });

    result.querySelectorAll('[data-rq-add]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = { id: Number(btn.dataset.rqAdd), quantity: 1 };
        if (btn.dataset.rqPlan) item.selling_plan = Number(btn.dataset.rqPlan);
        addItems([item], btn, 'Added');
      });
    });

    const allBtn = result.querySelector('[data-rq-addall]');
    if (allBtn) allBtn.addEventListener('click', () => {
      const items = allBtn.dataset.rqAddall.split(',').map(id => ({ id: Number(id), quantity: 1 }));
      addItems(items, allBtn, 'Added to cart');
    });

    const restart = result.querySelector('[data-rq-restart]');
    if (restart) restart.addEventListener('click', () => {
      state.i = 0; state.answers = {};
      result.hidden = true; shell.hidden = false;
      render();
      shell.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  root.querySelector('[data-rq-start]').addEventListener('click', () => {
    intro.hidden = true;
    shell.hidden = false;
    render();
  });
  nextBtn.addEventListener('click', next);
  backBtn.addEventListener('click', back);
})();
